import { Routes } from '@angular/router';
import { superAdminGuard } from './auth/guards/super-admin.guard';

/** Everything behind the platform-admin guard. */
const protectedRoutes: Routes = [
  {
    path: 'painel',
    loadComponent: () =>
      import('./features/dashboard/pages/platform-dashboard/platform-dashboard').then(
        (m) => m.PlatformDashboard,
      ),
  },
  {
    path: 'organizacoes',
    loadComponent: () =>
      import('./features/organizations/pages/organization-list/organization-list').then(
        (m) => m.OrganizationList,
      ),
  },
  {
    path: 'organizacoes/nova',
    loadComponent: () =>
      import('./features/organizations/pages/organization-form/organization-form').then(
        (m) => m.OrganizationForm,
      ),
  },
  {
    path: 'organizacoes/:id',
    loadComponent: () =>
      import('./features/organizations/pages/organization-detail/organization-detail').then(
        (m) => m.OrganizationDetail,
      ),
  },
  {
    path: 'organizacoes/:id/editar',
    loadComponent: () =>
      import('./features/organizations/pages/organization-form/organization-form').then(
        (m) => m.OrganizationForm,
      ),
  },
  {
    path: 'usuarios',
    loadComponent: () =>
      import('./features/users/pages/user-list/user-list').then((m) => m.UserList),
  },
  {
    path: 'usuarios/novo',
    loadComponent: () =>
      import('./features/users/pages/user-form/user-form').then((m) => m.UserForm),
  },
  {
    path: 'usuarios/:id',
    loadComponent: () =>
      import('./features/users/pages/user-form/user-form').then((m) => m.UserForm),
  },
  {
    path: 'parametros',
    loadComponent: () =>
      import('./features/lookups/pages/lookup-settings/lookup-settings').then(
        (m) => m.LookupSettings,
      ),
  },
  {
    path: 'alterar-senha',
    loadComponent: () =>
      import('./auth/pages/change-password/change-password').then((m) => m.ChangePassword),
  },
];

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./auth/pages/login/login').then((m) => m.Login),
  },
  // Must precede the guarded parent: an empty-path parent with children consumes ''.
  { path: '', redirectTo: '/painel', pathMatch: 'full' },
  { path: '', canActivate: [superAdminGuard], children: protectedRoutes },
  { path: '**', redirectTo: '/painel' },
];
